import KeenSlider from 'keen-slider';
import { sliderOptions as brandOptions } from '../blocks/brands.js';
import { sliderOptions as cardOptions } from '../blocks/card-slider.js';
import '../pages/single-post.js';

const options = {
    'brand': brandOptions,
    'card': cardOptions
}

export function setUpSliders() {
    document.querySelectorAll( '[data-slider]' ).forEach( sliderEl => {
        const sliderOptions = options[sliderEl.dataset.slider];
        if ( !sliderOptions ) return;
        const slider = new KeenSlider( sliderEl, sliderOptions );
    } );
}